<template>
  <div class="error__wrapper">
    <div class="error__logo"><img :src="logo" alt="logo" /></div>
    <div class="error__container">
      <div class="error-title">{{ title }}</div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import AppLogo from "@/assets/images/app_logo.svg";
import withNavigate from "@/mixins/withNavigate";

export default Vue.component("ErrorLayout", {
  props: {
    title: VueTypes.string
  },
  mixins: [withNavigate],
  methods: {
    getBack() {
      this.$router.replace("/login");
    }
  },
  data() {
    return {
      logo: AppLogo
    };
  }
});
</script>

<style lang="scss" scoped>
$ns: "error";

.#{$ns}__wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 10vh 30vh;
  min-width: 0;

  .#{$ns}__logo {
    width: 200px;
    margin-bottom: 40px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.#{$ns}-title {
  color: $button-dark-color;
  text-align: center;
  font-size: 80px;
  margin-bottom: 70px;
}

@media screen and (max-width: 991px) {
  .#{$ns}__wrapper {
    padding: 10vh;
  }

  .#{$ns}-title {
    font-size: 60px;
  }
}
</style>

<style lang="scss">
$ns: "error";
.#{$ns}__title,
.#{$ns}-description,
.#{$ns}-additional-text {
  font-family: "Lato-Light", Arial, "Helvetica Neue", Helvetica, sans-serif;
  text-align: center;
  line-height: 1.3;
}

.#{$ns}-additional-text {
  color: $grey-dark;
}

.#{$ns}-description {
  font-weight: 300;
  text-align: center;

  &,
  a {
    font-size: 40px;
  }
}
@media screen and (max-width: 991px) {
  .#{$ns}__container {
    .#{$ns}-description {
      &,
      a {
        font-size: 30px;
      }
    }
  }
}
</style>
